import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

const adminNav = [
  { label: 'Dashboard', path: '/admin/dashboard' },
  { label: 'User Management', path: '/admin/users' },
  { label: 'Content Management', path: '/admin/content' },
  { label: 'Analytics Dashboard', path: '/admin/analytics' },
  { label: 'Revenue Sharing', path: '/admin/revenue' },
  { label: 'System Settings', path: '/admin/settings' },
  { label: 'Music Upload', path: '/admin/music-upload' },
];

const AdminLayout = ({ children }) => (
  <div className="flex min-h-screen bg-eduvibe-dark">
    {/* Sidebar */}
    <aside className="w-64 bg-[#14213d] text-white flex flex-col py-8 px-4 sticky top-0 h-screen z-30">
      <div className="text-2xl font-bold mb-10 text-eduvibe-green">EduVibe</div>
      <nav className="flex-1">
        <ul className="space-y-2">
          {adminNav.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `block px-4 py-2 rounded transition-colors duration-150 ${
                    isActive ? 'bg-eduvibe-green text-eduvibe-dark font-semibold' : 'hover:bg-eduvibe-blue/50'
                  }`
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
    {/* Main Content */}
    <main className="flex-1 p-8 mt-20 bg-eduvibe-dark text-white min-h-screen">
      {/* mt-20 to offset fixed header */}
      {children || <Outlet />}
    </main>
  </div>
);

export default AdminLayout;
